import "./category.css";
import "../Useful/useful.css";
import "bootstrap/dist/css/bootstrap.min.css";

import "react-slidedown/lib/slidedown.css";
////////////////////
import React, { useEffect, useState } from "react";
import { Header_panel } from "../Useful/Useful";
import { Button, Form } from "reactstrap";
import Spinner from "react-bootstrap/Spinner";
import { useParams } from "react-router-dom";

import { provinceGetById } from "../../fetch";

export default function AddProvince(props) {
  // const id = useParams();
  // console.log(id);
  console.log(props);
  const [setting, setSetting] = useState({
    name: "",
  });
  const { name } = setting;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // setLoading(true);
    provinceGetById(props.id)
      .then((response) => {
        setLoading(false);

        return response.json();
      })
      .then((responseJson) => {
        setSetting({
          name: responseJson.result.name,
        });
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
    var htmlInput = document.getElementById("name");

    htmlInput.oninvalid = function (e) {
      e.target.setCustomValidity("لطفا نام استان  را وارد کنید");
      htmlInput.oninput = function (e) {
        e.target.setCustomValidity("");
      };
    };
  }, [props.id]);

  const onSubmit = (e) => {
    setLoading(true);
    e.preventDefault();

    var Data = {
      id: props.id == null || undefined ? "" : props.id,
      name: e.target.name.value,
    };
    props.onFormSubmit(Data);
    setSetting({
      name: "",
    });
    setLoading(false);
  };

  const handleChange = (name) => (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    event.persist();
    setSetting((prevState) => ({ ...prevState, [name]: value }));
  };

  return (
    <div className="col-lg-12 mypanel shadow">
      <Header_panel title="افزودن استان" idMenu={props.navid} />
      <div className="pos-f-t">
        <div className="collapse" id="navbarToggleExternalContentSettingAdd1">
          <Form onSubmit={onSubmit}>
            <div className="row p-4">
              <div className="col-lg-6">
                <div className="form-group textg">
                  <label className="control-label" htmlFor="first_name">
                    * نام استان
                  </label>
                  <input
                    required
                    value={name}
                    id="name"
                    onChange={handleChange("name")}
                    className="contactInput form-control"
                    name="name"
                    placeholder="نام استان ..."
                  />
                </div>
              </div>
            </div>

            {loading && (
              <Spinner
                className="buttonProgress"
                animation="border"
                variant="primary"
              />
            )}
            <Button type="submit" color="primary" id="regProdbtn">
              ذخیره
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}
